import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { API, useAuth } from "@/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import AuctionCard from "@/components/AuctionCard";
import { STATUS_LABELS, formatAZN } from "@/lib/format";

export default function DashboardPage() {
  const { user, authHeaders } = useAuth();
  const nav = useNavigate();
  const [my, setMy] = useState([]);
  const [bids, setBids] = useState([]);
  const [favs, setFavs] = useState([]);

  useEffect(() => {
    if (!user) { nav("/login"); return; }
    const h = { headers: authHeaders() };
    axios.get(`${API}/dashboard/my-auctions`, h).then(r => setMy(r.data));
    axios.get(`${API}/dashboard/my-bids`, h).then(r => setBids(r.data));
    axios.get(`${API}/dashboard/favorites`, h).then(r => setFavs(r.data));
  }, [user]);

  if (!user) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 fade-in">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tighter text-slate-900">Salam, {user.first_name}</h1>
      <p className="text-slate-500 mt-1">İdarəetmə paneli</p>

      <Tabs defaultValue="auctions" className="mt-8">
        <TabsList className="rounded-full bg-slate-100 p-1">
          <TabsTrigger value="auctions" data-testid="tab-auctions" className="rounded-full px-6">Mənim auksionlarım ({my.length})</TabsTrigger>
          <TabsTrigger value="bids" data-testid="tab-bids" className="rounded-full px-6">Təkliflərim ({bids.length})</TabsTrigger>
          <TabsTrigger value="favs" data-testid="tab-favs" className="rounded-full px-6">Favorilər ({favs.length})</TabsTrigger>
        </TabsList>

        <TabsContent value="auctions" className="mt-6">
          {my.length === 0 ? (
            <div className="text-center py-16 border-2 border-dashed border-slate-200 rounded-2xl">
              <p className="text-slate-500">Hələ auksion yaratmamısınız</p>
              <Link to="/sell" className="text-blue-600 font-semibold mt-2 inline-block">İlk auksiona başla →</Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {my.map(a => <AuctionCard key={a.id} a={a} />)}
            </div>
          )}
        </TabsContent>

        <TabsContent value="bids" className="mt-6">
          {bids.length === 0 ? <p className="text-slate-500 text-center py-16">Hələ təklif verməmisiniz</p> : (
            <div className="rounded-2xl border border-slate-200 divide-y divide-slate-100 overflow-hidden bg-white">
              {bids.map(({bid, auction}) => (
                <Link key={bid.id} to={`/auction/${auction.slug || auction.id}`} className="flex items-center justify-between p-4 hover:bg-slate-50 transition-colors">
                  <div className="flex items-center gap-4">
                    <img src={auction.images?.[0] || "https://images.unsplash.com/photo-1592309905620-e5b59f6dcb98?w=200"} alt="" className="h-16 w-20 rounded-lg object-cover" />
                    <div>
                      <div className="font-bold text-slate-900">{auction.vehicle.brand} {auction.vehicle.model}</div>
                      <div className="text-xs text-slate-500">{STATUS_LABELS[auction.status]} • Cari: {formatAZN(auction.current_price)}</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-mono font-bold">{formatAZN(bid.amount)}</div>
                    <div className="text-xs text-slate-500">{new Date(bid.created_at).toLocaleDateString("az-AZ")}</div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </TabsContent>

        <TabsContent value="favs" className="mt-6">
          {favs.length === 0 ? <p className="text-slate-500 text-center py-16">Favori yoxdur</p> : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {favs.map(a => <AuctionCard key={a.id} a={a} />)}
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
}
